import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'
import { Heading, ContainerBox } from './AdminStyle';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

@inject('residenceBookingStore', 'userStore', 'adminStore', 'partnersStore')

@observer
class ResidenceBookings extends Component {

  componentWillMount() {
    this.props.residenceBookingStore.getActiveBookings()
  }

  sortDates(a, b, order) {
    let indices = [6, 7, 8, 9, 3, 4, 0, 1];
    if (order === 'asc') {
      let r = 0;
      indices.find(i => r = a.date.charCodeAt(i) - b.date.charCodeAt(i));
      return r;
    } else if (order === 'desc') {
      let r = 0;
      indices.find(i => r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i));
      return r;
    }
  }

  render() {
    const { isAdmin, isLoge } = this.props.userStore;
    const { isAllActiveBookings, allResidenceBookings } = this.props.residenceBookingStore;
    let bookings = []

    if (isAllActiveBookings) {
      allResidenceBookings.map((booking, idx) =>
        bookings.push({
          idx: idx + 1,
          objectId: booking.objectId,
          date: moment(booking.createdAt).locale("en").format('DD.MM.YYYY - HH:mm'),
          from: moment(booking.arrival.iso).subtract(2, 'hours').locale("de").format('DD/MM/YYYY'),
          to: moment(booking.depature.iso).subtract(2, 'hours').locale("de").format('DD/MM/YYYY'),
          arrivalTime: booking.arrivalTime,
          company: booking.company.name,
          name: booking.user.firstname + " " + booking.user.lastname,
        })
      )
    }


    if (!isAdmin) {
      //this.props.history.push("/")
    }


    return (
      <div>
      {(isAdmin || isLoge) ?
          <div>
            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox>
                  <Heading>RESIDENCE BUCHUNGEN</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table'}>
                    {!isAllActiveBookings
                      ? "Keine Residence Buchungen"
                      : <BootstrapTable data={bookings} borderless={true} hover={true} search pagination>
                        <TableHeaderColumn dataField="objectId" isKey>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="date" dataSort={true}>gebucht am</TableHeaderColumn>
                        <TableHeaderColumn dataField="from" dataSort={true} sortFunc={this.sortDates}>Anreise</TableHeaderColumn>
                        <TableHeaderColumn dataField="to">Abreise</TableHeaderColumn>
                        <TableHeaderColumn dataField="arrivalTime">Ankunftszeit</TableHeaderColumn>
                        <TableHeaderColumn dataField="company" dataSort={true}>Firma</TableHeaderColumn>
                        <TableHeaderColumn dataField="name" dataSort={true}>Name</TableHeaderColumn>
                      </BootstrapTable>
                    }
                  </div>
                </ContainerBox>
              </Col>
            </Row>
          </div>
          : ''}

      </div>
    )
  }
}

ResidenceBookings.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject
}

export default ResidenceBookings



// WEBPACK FOOTER //
// /src/components/admin/ResidenceBookings.js